import { Component, OnInit } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { DataHelper } from '@helpers/data.helper';
import { Router } from '@angular/router';
import { ApiService } from '@services/api.service';
import { StandingsDialogComponent } from '@components/standings.dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { UserHelper } from '@helpers/user.helper';
import { sportsSvgList } from '@app/constants/svgUrl.constant';
import { CasinoRoutingDialog } from './casino-routing-dialog';
import { SureRoutingDialog } from './sure-routing-dialog.ts';
import { CasinoRegisterModal } from './casino-register-modal';
interface LeftMenuItem {
  sportId: number;
  routeId: number;
  index: number;
  svgPath: string;
  title: string;
  projectControl: string[];
  ngIf: () => boolean;
  order: number;
}
@Component({
  selector: 'left-menu',
  templateUrl: '../sharedTemplates/left-menu.component.html',
})
export class LeftMenuComponent implements OnInit {
  topCountries = [];
  mainData = [];
  selectedSportId: any;
  lastReturned_dayFilter = 0;
  _dayFilter = 300;
  selectedLeagueData = [];
  narvbarDateTimeInterval;
  narvbarDateTime = '';
  public sportsSvgList = sportsSvgList;
  leftMenuGeneralData = [
    {
      routerLink: '/casino/lobby/1/0',
      svgPath: `casino`,
      title: 'casino.lobby.slot',
      isShowProject: [],
      ngIf: () => this._UserHelper.isSignedIn && this._UserHelper?.customerUser?.IsView === 'True',
      order: 1,
    },
    {
      routerLink: '/casino/lobby/0/1',
      svgPath: `casino`,
      title: 'Gry',
      isShowProject: [],
      ngIf: () => this._UserHelper.isSignedIn && this._UserHelper?.customerUser?.IsView === 'True',
      order: 1,
    },
    {
      routerLink: '/casino/lobby/2/0',
      svgPath: `casino`,
      title: 'casino.lobby.livecasino',
      isShowProject: [],
      ngIf: () => this._UserHelper.isSignedIn && this._UserHelper?.customerUser?.IsView === 'True',
      order: 1,
    },
    {
      routerLink: '/casino/lobby/5/0',
      svgPath: `casino`,
      title: 'casino.lobby.virtual',
      isShowProject: [],
      ngIf: () => this._UserHelper.isSignedIn && this._UserHelper?.customerUser?.IsView === 'True',
      order: 1,
    },
    {
      standingType: 'livescore',
      svgPath: `statistiken`,
      title: 'statistics',
      isShowProject: [],
      ngIf: () => true,
      order: 3,
    },
    {
      standingType: 'statistics',
      svgPath: `ergebnisse`,
      title: 'Results',
      isShowProject: [],
      ngIf: () => true,
      order: 4,
    },
    {
      routerLink: '/favorites',
      svgPath: `favoriten`,
      title: 'Favourite',
      isShowProject: [],
      ngIf: () => true,
      order: 5,
    },
  ];

  constructor(
    public _UiHelper: UiHelper,
    public _LocalizationService: LocalizationService,
    private _DataHelper: DataHelper,
    private _router: Router,
    private _ApiService: ApiService,
    public dialog: MatDialog,
    public _UserHelper: UserHelper,
    public _MatDialog: MatDialog,
    public _Router: Router
  ) {
    this._UiHelper.currentRouteListener.subscribe((x: any) => {
      this.closeLeftMenu();
    });
    this._DataHelper.LeagueDataListener.subscribe(x => {
      if (this._DataHelper.LeagueData != undefined) {
        this.selectedLeagueData = this._DataHelper.LeagueData;
      }
    });
  }

  leftSportMenuOpen() {
    this._DataHelper.LeagueData = undefined;
    this._DataHelper.leftMenuSportData = undefined;
    this._UiHelper.setLeftSportsMenuDialog(true);
    this._UiHelper.setLeftMenu();
  }

  ngOnInit() {
    this._DataHelper.leftMenuSportData = undefined;

    if (this._DataHelper.leftMenuSportData != undefined) {
      if (this._DataHelper.leftMenuSportData.length != 0) this.mainData = this._DataHelper.leftMenuSportData;
      else this.getSports();
    } else this.getSports();

    this.changeDayFilter({ source: null, value: '300' });
  }
  ngAfterViewInit() {
    this.narvbarDateTimeInterval = setInterval(() => {
      const narvbarTime = new Date().toLocaleTimeString();
      const narvbarDate = new Date().toLocaleDateString();
      this.narvbarDateTime = narvbarDate + ' - ' + narvbarTime;
    }, 1000);
  }
  ngOnDestroy() {
    if (this.narvbarDateTimeInterval) {
      clearInterval(this.narvbarDateTimeInterval);
    }
  }

  leftMenuGeneralDataRebuild(values) {
    return values.filter(item => (item.isShowProject.length > 0 ? item.isShowProject.includes(environment.product) : true) && item.ngIf()).sort((a, b) => a.order - b.order);
  }

  closeLeftMenu() {
    this._UiHelper.p1001SetLeftMenuState('close');
  }

  searchClick() {
    this._UiHelper.closeDimmer(this._UserHelper.isSignedIn);
    this._DataHelper.preMatchobservable.next([]);
    this._Router.navigate(['search']);
  }

  clickOutside(event: any) {
    if (event && event.targetElement.id != 'leftMenuIcon' && event.clickInside == false) {
      // todo
    }
  }

  openStats(e) {
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialogNoPadding',
      panelClass: 'standingsDialogClass',
      height: '90%',
      width: '90%',
      data: {
        tournamentId: '',
        sportId: '',
        betradarMatchId: '',
        type: e,
      },
    });
    this._UiHelper.closeDimmer(this._UserHelper.isSignedIn);
  }
  getCountriesBySportsID(_sportID, _index) {
    const objSport = {
      sportId: _sportID,
      index: _index,
    };
    this._UiHelper.leftMenuSportSelected(objSport);
    this._UiHelper.closeDimmer(this._UserHelper.isSignedIn);
    this._DataHelper.liveHeaderTitle = _sportID?.sportName;
  }
  getSports(__dayFilter = 300) {
    if (this.lastReturned_dayFilter != __dayFilter || this.lastReturned_dayFilter == 0) {
      this._ApiService
        .getSports(__dayFilter)
        .then(x => {
          this.mainData = x.map(x => {
            x['level'] = [];
            x['loading'] = false;
            x['state'] = false;
            return x;
          });
          this.lastReturned_dayFilter = __dayFilter;
          this.getCountriesBySportsID(1, 0);
        })
        .catch(err => console.log('left-menu', err));
    }
  }
  changeDayFilter(e) {
    if (e.value == undefined) {
      return;
    }

    this._DataHelper.leftMenuSportDayFilter = e.value;

    if (this._dayFilter != e.value) {
      e != undefined ? this.getSports(e.value) : null;
      this._dayFilter = e.value;
    }
  }

  openCasinop1001() {
    if (this._UserHelper.isSignedIn) {
      const dialogRef = this._MatDialog;
      this._ApiService.getCasinoRegisterInfo().then(result => {
        if (result && !result.Success) {
          this._UiHelper.closeAllMenus();
          dialogRef.open(CasinoRegisterModal, {
            width: '550px',
            panelClass: 'casino-dialog',
            data: result,
          });
        } else {
          if (this._UiHelper.insicStatus === 2) {
            this._UiHelper.closeAllMenus();
            dialogRef.open(CasinoRoutingDialog, {
              width: '350px',
              panelClass: 'casino-dialog',
            });
          } else {
            dialogRef.open(SureRoutingDialog, {
              width: '350px',
              panelClass: 'casino-dialog',
            });
          }
        }
      });
    } else {
      this._UiHelper.dimmerListener.emit({
        status: 'open',
        modalId: 'loginDimmer',
      });
    }
  }
}
